export default "__VITE_ASSET__BeSmhDP5__"